// tslint:disable:max-line-length
import * as React from 'react';
import { createIcon } from '../icon';

export const ShareFb = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g fill="#C9C9C9" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M14.5 27.5c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13v1c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14v-1z"
      />
      <path d="M10.969 11.903h1.348v-1.309c0-.577.015-1.468.434-2.02.442-.584 1.049-.98 2.092-.98 1.699 0 2.416.241 2.416.241l-.336 1.997s-.563-.162-1.086-.162c-.524 0-.994.187-.994.712v1.521h2.148l-.148 1.95h-2v6.774h-2.526v-6.774H10.97v-1.95z" />
    </g>
  </svg>,
);

ShareFb.displayName = 'ShareFb';

export const ShareInstagram = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#C9C9C9"
        fillRule="nonzero"
        d="M14.5 27.5c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13v1c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14v-1z"
      />
      <path
        fill="#CCC"
        d="M14.505 7.996c2.118 0 2.37.01 3.206.048.773.036 1.192.165 1.472.274.371.143.635.315.912.593.278.277.45.541.593.912.11.28.238.7.274 1.473.038.837.047 1.088.047 3.206s-.01 2.37-.05 3.206c-.04.774-.168 1.193-.278 1.473-.148.37-.317.635-.595.912-.277.278-.545.45-.912.593-.277.11-.704.238-1.477.274-.843.038-1.091.047-3.213.047s-2.37-.01-3.213-.05c-.774-.04-1.2-.169-1.478-.278a2.469 2.469 0 0 1-.912-.595 2.427 2.427 0 0 1-.595-.912c-.11-.278-.238-.704-.278-1.478-.03-.833-.04-1.09-.04-3.203 0-2.112.01-2.37.04-3.213.04-.774.169-1.2.278-1.478.139-.377.317-.634.595-.912.278-.278.535-.456.912-.595.278-.11.694-.238 1.468-.278.843-.03 1.09-.04 3.213-.04l.03.021zm0 2.432a4.074 4.074 0 1 0 4.076 4.074 4.074 4.074 0 0 0-4.075-4.074zm0 6.719a2.645 2.645 0 1 1 0-5.29 2.645 2.645 0 0 1 0 5.29zm5.186-6.88a.952.952 0 1 1-1.905 0 .952.952 0 0 1 1.905 0z"
      />
    </g>
  </svg>,
);

ShareInstagram.displayName = 'ShareInstagram';

export const ShareVk = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g fill="#C9C9C9" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M14.5 27.5c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13v1c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14v-1z"
      />
      <path d="M13.828 19.526h.957s.288-.032.436-.19c.14-.147.14-.42.14-.42s-.02-1.284.58-1.473c.59-.187 1.34 1.24 2.14 1.788.61.42 1.07.33 1.07.33l2.14-.03s1.12-.07.59-.95c-.04-.07-.3-.65-1.58-1.84-1.34-1.24-1.16-1.04.45-3.19.98-1.31 1.38-2.11 1.25-2.45-.11-.32-.84-.24-.84-.24l-2.4.02s-.18-.02-.31.06-.21.26-.21.26-.38 1.02-.89 1.88C16.27 14.9 15.84 15 15.67 14.88c-.403-.26-.3-1.053-.3-1.62 0-1.76.27-2.5-.52-2.69-.26-.06-.454-.1-1.123-.11-.86-.01-1.585.006-1.996.207-.27.135-.48.434-.36.45.16.02.52.098.71.358.25.337.24 1.09.24 1.09s.14 2.077-.33 2.335c-.33.174-.77-.187-1.73-1.837-.49-.84-.86-1.78-.86-1.78s-.07-.17-.2-.27c-.15-.11-.37-.15-.37-.15l-2.29.02s-.34.01-.46.16c-.11.13-.01.41-.01.41s1.79 4.19 3.82 6.3c1.86 1.935 3.97 1.81 3.97 1.81l-.033-.037z" />
    </g>
  </svg>,
);

ShareVk.displayName = 'ShareVk';

export const ShareTelegram = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#C9C9C9"
        fillRule="nonzero"
        d="M14.5 27.5c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13v1c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14v-1z"
      />
      <path
        fill="#CCC"
        d="M17.407 17.71c.465-1.272 2.168-6.103 2.44-7.369.31-1.434-.338-1.572-1.809-1.092-1.47.481-5.243 1.878-5.878 2.104-.636.226-3.726 1.264-4.367 1.574-1.308.702-.672 1.774.79 2.33 4.375 2.1 3.133 1.03 5.086 4.914.401.993 1.349 2.683 2.256 1.405.478-.727 1.117-2.868 1.483-3.868v.001z"
      />
    </g>
  </svg>,
);

ShareTelegram.displayName = 'ShareTelegram';

export const ShareYoutube = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#C9C9C9"
        fillRule="nonzero"
        d="M14.5 27.5c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13v1c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14v-1z"
      />
      <path
        fill="#CCC"
        d="M7 14.01c0-1.212.15-2.427.15-2.427s.146-1.031.596-1.488c.57-.597 1.32-.578 1.654-.641 1.2-.117 5.1-.15 5.1-.15s3.152.003 5.25.155c.294.036.934.038 1.504.636.45.456.596 1.489.596 1.489s.15 1.213.15 2.428v1.18c0 1.214-.15 2.427-.15 2.427s-.146 1.034-.596 1.49c-.57.597-1.21.6-1.504.635-2.098.152-5.25.155-5.25.155s-3.9-.034-5.1-.15c-.334-.062-1.084-.044-1.654-.64-.45-.457-.596-1.489-.596-1.489S7 16.406 7 15.192v-1.181zm5.951 2.56v-4.214l4.053 2.114-4.05 2.1h-.003z"
      />
    </g>
  </svg>,
);

ShareYoutube.displayName = 'ShareYoutube';
